import axios from "../axios";

export const fetchProcessingFeeVendorStarted = () => {
  return {
    type: "GET_PROCESSING_FEE_VENDOR_STARTED",
  };
};

export const fetchProcessingFeeVendorSuccess = (post) => {
  return {
    type: "GET_PROCESSING_FEE_VENDOR_SUCCESS",
    data: post,
  };
};

export const fetchProcessingFeeVendorFailure = (error) => {
  console.log("Unable to get processing fee data");
  return {
    type: "GET_PROCESSING_FEE_VENDOR_FAILURE",
    data: error,
  };
};

export const fetchProcessingFeeVendor = () => {
  return (dispatch) => {
    dispatch(fetchProcessingFeeVendorStarted());
    return axios
      .get("/processingfeeVendor")
      .then((response) => {
        dispatch(fetchProcessingFeeVendorSuccess(response.data[0]));
      })
      .catch((error) => {
        dispatch(fetchProcessingFeeVendorFailure(error));
      });
  };
};

export const updateProcessingFeeVendorStarted = (data) => {
  return {
    type: "UPDATE_PROCESSING_FEE_VENDOR_STARTED",
    data: data,
  };
};

export const updateProcessingFeeVendorSuccess = (data) => {
  return {
    type: "UPDATE_PROCESSING_FEE_VENDOR_SUCCESS",
    data: data,
  };
};

export const updateProcessingFeeVendorFailure = (error) => {
  console.log("Unable to update processing fee data", error);
  return {
    type: "UPDATE_PROCESSING_FEE_VENDOR_FAILURE",
    data: error,
  };
};

export const updateProcessingFeeVendor = (data) => {
  return (dispatch) => {
    dispatch(updateProcessingFeeVendorStarted(data));
    return axios
      .put("/processingfeeVendor", data)
      .then((response) => {
        dispatch(updateProcessingFeeVendorSuccess(response));
        dispatch(fetchProcessingFeeVendor());
      })
      .catch((error) => {
        dispatch(updateProcessingFeeVendorFailure(error));
      });
  };
};
